import React from "react";
import { Paragraph } from "../typography";
import Page from "../components/Page";

const StatementPage: React.FC = () => (
  <Page title="Statement">
    <Paragraph>
      My work has always focused on the foundations of pottery such as
      materials, processes and community. The work reflects my passion for
      natural systems, stemming from 25 years studying ecology and natural
      sciences. Pottery reminds us of humble beginnings, and the temperance of
      time. Woodfired pottery is an ancient process that brings us back to a
      time before globalization, when the work was created out a necessity and
      it’s beauty stemmed from natural variation in materials and process. Now,
      in an age of ‘cookiecutter’ suburbs and Ikea kitchenware, handmade pottery
      has the power to remind of us of the essentials: living presently,
      surrounded by community and providing beauty for daily moments.{" "}
    </Paragraph>
  </Page>
);

export default StatementPage;
